import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    planesPagos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    
    filtroNoCancelados: true,
    incluirPlanesCancelados: false,
    fechaDesdeTodos: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHastaTodos: moment(new Date()).format('YYYY-MM-DD'),
    fechaDesdeCancelados: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHastaCancelados: moment(new Date()).format('YYYY-MM-DD'),
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.planesPagos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.filtroNoCancelados = true;
        state.incluirTodosPlanesNoCancelados = true;
        state.incluirPlanesCancelados = false;
        state.fechaDesdeTodos = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHastaTodos = moment(new Date()).format('YYYY-MM-DD');
        state.fechaDesdeCancelados = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHastaCancelados = moment(new Date()).format('YYYY-MM-DD');
    },

    'INICIALIZAR_PLANES_PAGOS' (state) {
        state.planesPagos = [];
    },
    'SET_PLANES_PAGOS' (state, planesPagos) {
        state.planesPagos = planesPagos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getPlanesPagos ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PLANES_PAGOS');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            if ((/true/i).test(state.filtroNoCancelados)) {
                queryString += '&incluirTodosPlanesNoCancelados=true'
                    + '&incluirPlanesCancelados=' + (/true/i).test(state.incluirPlanesCancelados)
                    + '&fechaDesde='+ moment(state.fechaDesdeCancelados).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHastaCancelados).format('YYYY-MM-DD');
            } else {
                queryString += '&incluirTodosPlanesNoCancelados=false'
                    + '&incluirPlanesCancelados=false'
                    + '&fechaDesde='+ moment(state.fechaDesdeTodos).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHastaTodos).format('YYYY-MM-DD');
            }
            

            apiAxios.get('planespagos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_PLANES_PAGOS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },

    // delete ( {}, tarjetaResumenId ) {
    //     return new Promise((resolve, reject) => {
    //         apiAxios.post('planesPagos/' + tarjetaResumenId + '/delete')
    //             .then(() => resolve())
    //             .catch(error => reject(helpers.methods.getErrorMessage(error)));
    //     })            
    // },

    refinanciar ( {}, params ) {
        return new Promise((resolve, reject) => {
            let planPagos = {
                numero: params.numero.toUpperCase().trim(),
                fechaVencimientoInicial: moment.utc(params.fechaVencimientoInicial).format('YYYY-MM-DD'),
                bancoCuentaId: parseInt(params.bancoCuentaId),
                cantidadCuotas: parseInt(params.cantidadCuotas),
                importe: parseFloat(params.importe),
                importeIntereses: parseFloat(params.importeIntereses)
            }

            apiAxios.post(`planesPagos/${params.planPagosId}/refinanciar`, planPagos)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}